import script from "./EditTable.vue?vue&type=script&setup=true&lang=js"
export * from "./EditTable.vue?vue&type=script&setup=true&lang=js"

import "./EditTable.vue?vue&type=style&index=0&id=38eb8975&lang=scss"

const __exports__ = script;

export default __exports__